var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 5.71387H5.71316V12.571H4.57031V5.71387Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.71387H9.14285V12.571H8V5.71387Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.28613V3.42898H1.14285V14.8575C1.14285 15.1606 1.26326 15.4513 1.47758 15.6656C1.69191 15.8799 1.98259 16.0003 2.2857 16.0003H11.4285C11.7316 16.0003 12.0223 15.8799 12.2366 15.6656C12.4509 15.4513 12.5713 15.1606 12.5713 14.8575V3.42898H13.7142V2.28613H0ZM2.2857 14.8575V3.42898H11.4285V14.8575H2.2857Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 0H9.14171V1.14285H4.57031V0Z",
    fill: "#828282"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/BinIcon.0e20d860b5f0960c5e8ede20853edd3a.svg";
export { ForwardRef as ReactComponent };